import "./App.css";
import Login from "./authentication/Login";
import NewPassword from "./authentication/NewPassword";
import OTP from "./authentication/OTP";
import ResetPassword from "./authentication/ResetPassword";
import Sidenav from "./dashboard/Sidenav";
import RequireAuth from "./components/RequireAuth";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Missing from "./other/Missing";
import Unauthorised from "./other/Unauthorised";
import PersistLogin from "./components/PersistLogin";
import Home from "./dashboard/Home";
import Admins from "./pages/Admins";
import Workers from "./pages/Workers";
import Jobs from "./pages/Jobs";
import Speciality from "./pages/Speciality";
import Expenses from "./pages/Expenses";
import Revenue from "./pages/Revenue";
import Locations from "./pages/Locations";
import Customers from "./pages/Customers";
import Profile from "./pages/Profile";
import Faqs from "./pages/Faqs";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* public routes */}
        <Route path="login" element={<Login />} />
        <Route path="otp" element={<OTP />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="new-password" element={<NewPassword />} />
        <Route path="unauthorised" element={<Unauthorised />} />

        {/* Add Linkage route */}
        {/* Protected routes: Only Managers(1) & Admins(2) */}
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[1, 2]} />}>
            <Route element={<Sidenav />}>
              <Route path="/" element={<Home />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="admins" element={<Admins />} />
              {/*  <Route path="tenant-admins" element={<TenantAdmins />} /> */}
              <Route path="workers" element={<Workers />} />
              <Route path="specialities" element={<Speciality />} />
              {/*  <Route path="roles" element={<Roles />} />
              <Route path="status" element={<Status />} /> */}
              <Route path="branches" element={<Locations />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="revenue" element={<Revenue />} />
              <Route path="customers" element={<Customers />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/faqs" element={<Faqs />} />
              {/* <Route path="payment-modes" element={<PaymentModes />} /> */}
              {/*  <Route path="tenants" element={<Tenants />} /> */}
            </Route>
          </Route>
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Missing />} />
      </Route>
    </Routes>

    /* <>
      <Routes>
        <Route path='/' element={<Login />}/>
        <Route path='sidenav' element={<Sidenav />}/>
        <Route path='reset-password' element={<ResetPassword />}/>
        <Route path='otp' element={<OTP />}/>
      </Routes>
    </> */
  );
}

export default App;
